<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-container ma-0 pa-0 px-4 class="container-with-horizontal-scroll" fluid>
            <v-row>
                <v-col sm="12" xs="8" md="3" class="pa-1 ma-0">
                    <v-card class="blue-grey lighten-5 d-flex flex-column" height="100%">
                        <v-card-title class="ml-2 pa-1">
                            <v-list-item-title class="bold subtitle-1">
                                <v-row>
                                    <v-col cols="9" md7 class="pa-0 ma-0 ml-4">
                                        <span>Группы клиентов</span>
                                    </v-col>
                                    <v-col cols="2" md3 class="pa-0 ma-0">
                                        <v-btn
                                                x-small
                                                icon
                                                color="primary"
                                                v-if="visibleTransferToBotButton"
                                                @click="addJobTransferToBot"
                                        >
                                            <v-icon small>
                                                group_add
                                            </v-icon>
                                        </v-btn>
                                        <v-tooltip left bottom>
                                            <template v-slot:activator="{ on }">
                                                        <span v-on="on"
                                                              v-if="!visibleTransferToBotButton && !successTransferToBotButton"
                                                        >
                                                            {{jobTransferToBot.percent}} %</span>
                                            </template>
                                            <span>Прогресс выполнения загрузки пользователей из группы ВК</span>
                                        </v-tooltip>
                                    </v-col>
                                </v-row>
                            </v-list-item-title>
                        </v-card-title>
                        <div class="mb-auto" v-bind:style="[{height: (windowHeight - 170) + 'px'},{display: 'flex'},{'flex-direction': 'column'}]">
                            <div class="content">
                                <v-card-text class="pa-0 ma-0"
                                             v-for="(mailingGroup, index) in getMailingGroups"
                                             :key="mailingGroup.id"
                                             @click="selectMailingGroup(mailingGroup.id)"
                                >
                                    <client-card
                                            :selected="mailingGroupId === mailingGroup.id"
                                            :status="mailingGroup.status"
                                            :mailing="mailingGroup"
                                            :index="index"
                                            @editMailing="editMailing(index)"
                                            @viewMailing="viewMailing(index)"
                                            @removeMailing="removeMailing"
                                    ></client-card>
                                </v-card-text>
                            </div>
                        </div>
                        <v-card-actions class="ma-0 pa-0">
                            <client-mailing-group-form
                                    :index="indexEdit"
                                    :dialog="dialog"
                                    @addMailing="addMailing"
                                    @close="dialog = false"
                            ></client-mailing-group-form>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col sm="12" xs="8" md="9" class="pa-1 ma-0">
                    <v-card class="blue-grey lighten-5 d-flex flex-column">
                        <v-card-title class="ml-2 pa-1">
                            <v-list-item-title class="bold subtitle-1">
                                Список клиентов в группе
                            </v-list-item-title>
                        </v-card-title>
                        <v-card-text
                                class="pa-0"
                        >
                            <client-table :mailingGroupId="mailingGroupId"
                            ></client-table>
                            <!--Список клиентов-->
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <v-snackbar
                v-model="snackbar"
                bottom
                :color="paramsSnackbar.color"
                right
        >
            {{paramsSnackbar.text}}
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import ClientMailingGroupForm from '../../components/bot/client/ClientMailingGroupForm'
import ClientCard from '../../components/bot/client/ClientCard'
import ClientTable from '../../components/bot/client/ClientTable'
import { mapGetters } from 'vuex'

export default {
    name: 'Index',
    components: {
        ClientMailingGroupForm,
        ClientCard,
        ClientTable
    },
    data() {
        return {
            dialog: false,
            indexEdit: null,
            jobTransferToBot: {
                percent: 0
            },
            mailingGroups: [],
            mailingGroupId: 0,
            visibleTransferToBotButton: false,
            successTransferToBotButton: true,
            paramsSnackbar: {
                color: 'success',
                text: 'Успешно сохранено!'
            },
            snackbar: false,
            windowHeight: 0
        }
    },
    methods: {
        selectMailingGroup(groupId) {
            let mailingGroup = this.getMailingGroups.find(group => group.id === +groupId)
            this.mailingGroupId = mailingGroup.id
            this.$route.params.groupId = this.mailingGroupId
            history.pushState({}, null, '/bot' + this.$route.params['pathMatch'] + '/client' + (this.mailingGroupId === 0 ? '' : this.mailingGroupId))
        },
        editMailing(index) {
            this.indexEdit = index
            this.dialog = true
        },
        addMailing(data) {
            this.mailings.push(data)
        },
        removeMailing(index) {
            this.mailings.splice(index, 1)
        },
        addJobTransferToBot() {
            let model = Object.assign({}, this.jobModelDefault)
            model.bot_id = this.$route.params['pathMatch']
            model.category = 'client'
            model.method = 'transfer_to_bot'
            model.status = 'success'
            this.$store.dispatch('jobs/createJob', model).then(response => {
                if (response !== undefined && response.data.hasOwnProperty('success')) {
                    this.paramsSnackbar.color = 'success'
                    this.paramsSnackbar.text = 'Загрузка пользователей из группы ВК началась!'
                } else {
                    this.paramsSnackbar.color = 'error'
                    this.paramsSnackbar.text = 'Ошибка при запуске загрзки пользователей из группы ВК'
                }
                this.snackbar = true
                this.getJobTransferToBot(true)
            }, error => {
                console.log(error)
            })
        },
        counterJobTransferToBot() {
            var timer = 300
            let seconds = setInterval(() => {
                timer = timer - 1
                if (timer <= 0 || this.jobTransferToBot.percent === 100) {
                    clearInterval(seconds)
                }
                this.getJobTransferToBot()
            }, 1000)
        },
        getJobTransferToBot(startCounter = false) {
            if (this.jobTransferToBot.percent === 100) {
                return
            }
            this.$store.dispatch('jobs/getJob', {
                bot_id: this.$route.params['pathMatch'],
                category: 'client',
                method: 'transfer_to_bot'
            }).then(response => {
                if (response !== undefined && response.data !== null && typeof response.data !== 'string' && typeof response.data === 'object') {
                    if (response.data.percent < 100) {
                        this.jobTransferToBot.percent = response.data.percent
                        if (startCounter) {
                            this.visibleTransferToBotButton = false
                            this.successTransferToBotButton = false
                            this.counterJobTransferToBot()
                        }
                    } else {
                        if (startCounter) {
                            this.successTransferToBotButton = true
                        }
                    }
                } else {
                    this.visibleTransferToBotButton = true
                }
            })
        },
        handleResize() {
            this.windowHeight = window.innerHeight
        }
    },
    created() {
        let botId = this.$route.params['pathMatch']
        this.$store.dispatch('clients/loadGroups', botId).then(response => {
            this.mailingGroupId = this.$route.params.hasOwnProperty('groupId') ? this.$route.params.groupId : 0
            this.selectMailingGroup(this.mailingGroupId)
        })
        this.getJobTransferToBot(true)
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
    },
    computed: {
        ...mapGetters({
            getMailingGroups: 'clients/allMailingGroups',
            clients: 'clients/clients',
            jobModelDefault: 'jobs/modelDefault'
        })
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    }
}
</script>

<style scoped lang="scss">
    ::-webkit-scrollbar {
        width: $width-scroll-panel;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $light;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $blue-active;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $blue-inactive;
    }
</style>
